module.exports = __webpack_public_path__ + "img/客户预开户操作手册4450.03dd1fbc.png";